import videojs from 'video.js';

export class PreRollPluginStub extends videojs.getPlugin('plugin') {
    constructor(player, options) {
        super(player, options);

        player.loader().onLoadPresentation(onLoadPresentation.bind(player));
    }
}

function shouldLoad(presentationId, playCoverData, presentationData) {
    const { playerExtensions } = presentationData;
    return playerExtensions?.some(ext => ext.ExtensionType === 'Mediasite.Player.CopyrightExtension');
}

async function onLoadPresentation(presentationId, playCoverData, presentationData) {
    const player = this;
    if (shouldLoad(...arguments)) {
        if (!videojs.getPlugin('preRoll')) {
            const { PreRollPlugin } = await import(/* webpackChunkName: 'pre-roll' */ './pre-roll.js');
            player.registerPlugin('preRoll', PreRollPlugin);
        }

        try {
            const extensionData = presentationData.playerExtensions.find(ext => ext.ExtensionType === 'Mediasite.Player.CopyrightExtension').Data;
            const { Text: text, Seconds: seconds } = JSON.parse(extensionData);
            player.preRoll().init({ text, seconds: parseInt(seconds, 10) });
        }
        catch (e) {
            this.log.warn('Unable to parse config data for the pre-roll message. Pre-roll message will not be displayed.');
        }
    }
}
